module.exports = __webpack_public_path__ + "static/make-video-slide3@2x-35daa668005af4d3713b606316f9f585.png";